export const accomodation = [
  {
    name: 'accomodation_info',
    value: '',
    type: 'textarea',
    placeholder: 'INFO',
    className: 'mt-2'
  }
];
